document.addEventListener('DOMContentLoaded', () => {
  // -------------------------------------------------------------------------
  // Optimización: almacenamiento en caché y gestión de estados
  // -------------------------------------------------------------------------
  // Caché local para almacenar el marcado del producto por identificador y variante
  // Esto evita múltiples solicitudes de red y parsing del mismo contenido.
  const modalCache = {};
  // Referencia global para la instancia activa de Flickity.  Antes de crear
  // una nueva instancia se destruye la anterior para liberar recursos.
  let flktyInstance = null;
  
  // Fetch and display product content when quick view triggers are clicked
  async function handleQuickViewClick(event, variantId = false) {
    const trigger = event.target.closest(".quick-view-trigger") ? event.target.closest(".quick-view-trigger") : event.target.closest(".sticky-quick-view__dropdown-item");
    if (!trigger) return;
    event.preventDefault();

    const handle = trigger.dataset.handle;
    if (!handle) return;

    try {
      const cacheKey = `${handle}::${variantId || 'default'}`;
      const contentContainer = document.getElementById('product-modal-content');
      // Si existe en caché, reutiliza el marcado previamente almacenado
      if (modalCache[cacheKey]) {
        const cached = modalCache[cacheKey];
        contentContainer.innerHTML = cached.mainHTML + cached.stickyHTML;
        // Inicializa el visor con los ajustes en caché
        await updateSlider(contentContainer, cached.settings);
        await setFirstTab(contentContainer);
        // Sólo abrir modal en el primer disparo (sin variante explícita)
        if (variantId === false) openModal();
        return;
      }

      // No hay caché: se realiza la solicitud al servidor
      const fetchUrl = variantId ? `/products/${handle}?variant=${variantId}` : `/products/${handle}`;
      const res = await fetch(fetchUrl);
      const htmlString = await res.text();

      const doc = new DOMParser().parseFromString(htmlString, 'text/html');
      const main = doc.getElementById('main');
      if (!main) throw new Error('No se encontró #main en la respuesta');

      const mainSection = main.querySelector('.main-product-info-container');
      const stickyQuickViewSection = doc.querySelector('.sticky-quick-view-section');

      // Extraer ajustes de la sección estática (si existen) para Flickity
      let settings = {};
      if (mainSection) {
        const staticScript = mainSection.querySelector('[data-section-type="static-product"]');
        if (staticScript) {
          try {
            const productData = JSON.parse(staticScript.innerHTML);
            settings = productData.settings || {};
          } catch (e) {
            console.warn('No se pudo parsear el JSON de settings:', e);
          }
        }
      }

      // Guardar en caché los bloques HTML (outerHTML) y los ajustes para futuras aperturas
      modalCache[cacheKey] = {
        mainHTML: mainSection ? mainSection.cloneNode(true).outerHTML : '',
        stickyHTML: stickyQuickViewSection ? stickyQuickViewSection.cloneNode(true).outerHTML : '',
        settings: settings
      };

      // Rellenar el contenedor con el contenido recien descargado
      contentContainer.innerHTML = modalCache[cacheKey].mainHTML + modalCache[cacheKey].stickyHTML;

      // Inicializar el slider con los ajustes extraídos
      await updateSlider(contentContainer, settings);
      await setFirstTab(contentContainer);

      if (variantId === false) openModal();
    } catch (err) {
      console.error('Error loading product modal:', err);
    }
  }

  function setFirstTab (contentContainer) {
    const lstTabs = contentContainer.querySelectorAll('.collapsible-tab');
    if (lstTabs.length > 0) {
      lstTabs[0].setAttribute('open', true);
    }
  }

  function updateSlider (contentContainer, externalSettings = {}) {
    const selectedFigure = contentContainer.querySelector('[data-gallery-selected="true"]');
    externalSettings.initialIndex = selectedFigure ? parseInt(selectedFigure.dataset.galleryIndex, 10) : 0;
    // Destruir instancia previa, si existe, antes de crear una nueva
    if (flktyInstance) {
      try {
        flktyInstance.destroy();
      } catch (e) {
        // Si destruir falla, ignorar el error y continuar
      }
      flktyInstance = null;
    }
    // Crear una nueva instancia de Flickity
    flktyInstance = new Flickity('#product-modal-content [data-gallery-viewer]', externalSettings);
    if (flktyInstance && typeof flktyInstance.resize === 'function') {
      flktyInstance.resize();
    }
  }

  function openModal() {
    const modal = document.getElementById("product-modal");
    modal.classList.remove("hidden");
    modal.setAttribute("aria-hidden", "false");
    // optionally lock body scroll
    document.body.style.overflow = "hidden";
  }

  function closeModal() {
    const modal = document.getElementById("product-modal");
    modal.classList.add("hidden");
    modal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    // clean up content for next open (optional)
    document.getElementById("product-modal-content").innerHTML = "";
  }

  // Optional: close modal on Escape key
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      const modal = document.getElementById("product-modal");
      if (!modal.classList.contains("hidden")) closeModal();
    }
  });

  let variantData = [];
  let selectedOptions = {};

  // Helper to find the sticky quick view element associated with a clicked element
  function findStickyBar(el) {
    return el.closest('.sticky-quick-view');
  }

  // Update variant and UI for a given sticky bar
  function updateVariant(stickyBar, state = false) {
    if (!stickyBar) return;
    let addButton = stickyBar.querySelector('.sticky-quick-view__add-to-cart');
    let priceContainer = addButton && addButton.querySelector('.sticky-quick-view__price');
    if (!addButton || !priceContainer) return;
    // Para mejorar el rendimiento, analizamos los datos de variantes una sola vez y los
    // almacenamos en la propiedad privada del sticky bar. Evita parsear JSON en
    // cada actualización.
    let variantDataLocal;
    if (stickyBar._parsedVariantData) {
      variantDataLocal = stickyBar._parsedVariantData;
    } else {
      variantDataLocal = stickyBar.dataset.variantData ? JSON.parse(stickyBar.dataset.variantData) : [];
      stickyBar._parsedVariantData = variantDataLocal;
    }
    variantData = variantDataLocal;

    // Initialise with the first variant’s options if available
    if (state && variantData.length > 0) {
      variantData[0].options.forEach(function (opt, idx) {
        selectedOptions[idx] = opt;
      });
    } else if (!state && variantData.length > 0) {
      let lstLabels = stickyBar.querySelectorAll('.sticky-quick-view__label');
      lstLabels.forEach((label, idx) => {
        selectedOptions[idx] = label.textContent.trim();
      });
    }
    
    let match = variantData.find(function (variant) {
      return variant.options.every(function (option, idx) {
        return selectedOptions[idx] === option;
      });
    });

    if (match) {
      addButton.dataset.variantId = match.id;
      priceContainer.textContent = '– ' + match.price;
      addButton.disabled = !match.available;
    } else {
      addButton.dataset.variantId = '';
      priceContainer.textContent = '';
      addButton.disabled = true;
    }
  }

  // Delegated click handling for dropdown toggles and items
  document.addEventListener('click', async function (event) {
    if (event.target && event.target.closest('.sticky-quick-view__dropdown-toggle')) {
      let dropdown = event.target.closest('.sticky-quick-view__dropdown');
      let stickyBar = findStickyBar(event.target);
      if (!dropdown || !stickyBar) return;
      let isOpen = dropdown.classList.contains('is-open');
      // Close any other open dropdowns within this sticky bar
      stickyBar.querySelectorAll('.sticky-quick-view__dropdown.is-open').forEach(function (otherDropdown) {
        if (otherDropdown !== dropdown) {
          otherDropdown.classList.remove('is-open');
          let otherToggle = otherDropdown.querySelector('.sticky-quick-view__dropdown-toggle');
          if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
        }
      });
      // Toggle the clicked dropdown
      dropdown.classList.toggle('is-open', !isOpen);
      event.target.closest('.sticky-quick-view__dropdown-toggle').setAttribute('aria-expanded', String(!isOpen));
      event.stopPropagation();
      return;
    } else if (event.target && event.target.closest('.sticky-quick-view__dropdown-item')) {
      let item = event.target.closest('.sticky-quick-view__dropdown-item');
      let value = item.getAttribute('data-value');
      let index = parseInt(item.getAttribute('data-index'), 10);
      let dropdown = item.closest('.sticky-quick-view__dropdown');
      let stickyBar = findStickyBar(item);
      if (!dropdown || !stickyBar) return;
      // Update selected option state
      selectedOptions[index] = value;
      // Update the toggle’s label and swatch
      let toggleBtn = dropdown.querySelector('.sticky-quick-view__dropdown-toggle');
      if (toggleBtn) {
        let labelSpan = toggleBtn.querySelector('.sticky-quick-view__label');
        if (labelSpan) labelSpan.textContent = value;
        let swatchSpan = toggleBtn.querySelector('.sticky-quick-view__color-swatch');
        if (swatchSpan && item.dataset.color) {
          swatchSpan.style.backgroundColor = item.dataset.color;
        }
        toggleBtn.setAttribute('aria-expanded', 'false');
      }
      // Close the dropdown
      dropdown.classList.remove('is-open');
      // Update variant and price
      updateVariant(stickyBar);
      const addButton = stickyBar.querySelector('.sticky-quick-view__add-to-cart');
      if (addButton) handleQuickViewClick(event, addButton.dataset.variantId);
    } else if (event.target && event.target.closest('.sticky-quick-view__add-to-cart')) {
      let addBtn = event.target.closest('.sticky-quick-view__add-to-cart');
      if (addBtn) {
        let variantId = addBtn.dataset.variantId;
        if (!variantId) return;
        addBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        })
          .then(function (response) { return response.json(); })
          .then(function (data) {
            document.dispatchEvent(new CustomEvent('product:added'));
            closeModal();
            addBtn.disabled = false;
            const sideCartButton = document.querySelector('.site-header-cart');
            if (sideCartButton) sideCartButton.click();
          })
          .catch(function () {
            addBtn.disabled = false;
          });
        event.stopPropagation();
      }
    } else if (event.target && event.target.closest(".quick-view-trigger")) {
      handleQuickViewClick(event);
    } else if (
      event.target &&
      (event.target.closest(".product-modal__close") ||
      event.target.matches(".product-modal__overlay"))
    ) {
      closeModal();
    }
    // Click outside: close all open dropdowns
    document.querySelectorAll('.sticky-quick-view__dropdown.is-open').forEach(function (openDropdown) {
      openDropdown.classList.remove('is-open');
      let t = openDropdown.querySelector('.sticky-quick-view__dropdown-toggle');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  });

  // Initialise variant display for any existing sticky bars on load
  document.querySelectorAll('.sticky-quick-view').forEach(function (bar) {
    updateVariant(bar, true);
  });
});